<script>
  // Firebase-DB-URL https://azubimesse-a993b.firebaseio.com/
  // https://github.com/mattiash/svelte-tablesort
  // npm install svelte-tablesort
  // https://www.npmjs.com/package/svelte-tablesort
  // https://stackoverflow.com/questions/45696999/fetch-unexpected-end-of-input
  // https://www.mediaevent.de/javascript/array-assoziativ.html

  // import { TableSort } from "svelte-tablesort";

  import Footer from "./div/Footer.svelte";
  import Raumplan from "./div/Raumplan.svelte";
  import LoadingSpinner from "./UI/LoadingSpinner.svelte";
  import { fly, fade } from "svelte/transition";

  let abfrage = [];
  let items = [];
  let suchbegriff = "";
  let suchergebnis = [];
  let anzeigeRaumplan = false;
  let raumplan = null;
  let isLoading = true;
  let showinfo = [];

  let bereich = "";
  let standnr = "";

  const dataPromise = fetch(
    "https://volksbankbocholt.de/pr/azubimesse/ausbildungsliste/admin/api/list/liste1?recperpage=400&order=Ausbildungsberufe&ordertype=ASC"
  )
    .then(r => {
      if (!r.ok) {
        throw new Error("Kein Raumplan gefunden. Bitte nocheinmal versuchen.");
      } else {
        return r.json();
      }
    })
    .then(data => {
      isLoading = false;
      abfrage = data.liste1;
      items = abfrage.groupBy("Ausbildungsberufe");
      // console.log(items);
    })
    .catch(error => {
      isLoading = false;
      console.log(error);
    });

  $: items = suchergebnis;

  function suche() {
    anzeigeRaumplan = false;
    if (suchbegriff.length >= 3) {
      suchergebnis = abfrage
        .filter(function(a) {
          return (
            a.Ausbildungsberufe.toLowerCase().includes(
              suchbegriff.trim().toLowerCase()
            ) ||
            a.tags.toLowerCase().includes(suchbegriff.trim().toLowerCase()) ||
            a.Firma.toLowerCase().includes(suchbegriff.trim().toLowerCase()) ||
            a.Beschreibung.toLowerCase().includes(
              suchbegriff.trim().toLowerCase()
            )
          );
          // https://stackoverflow.com/questions/31831651/javascript-filter-array-multiple-conditions
        })
        .groupBy("Ausbildungsberufe");
        window.scrollTo({ top: 100, left: 0, behavior: "smooth" });
        // window.scrollBy({ top: 40, left: 0, behavior: "smooth" });
    } else {
      suchergebnis = abfrage.groupBy("Ausbildungsberufe");
    }
  }

  function toggleRaumplan(b = "", s = "") {
    anzeigeRaumplan = !anzeigeRaumplan;
    bereich = b;
    standnr = s;
  }
</script>

<style>
  header h4 {
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    font-size: 2em;
    font-weight: 500;
    color: black;
    padding: 0.5rem;
    width:60%;
    margin:.2em 0 .2em 0;
  }

  main {
    width: 98%;
  }

  .raumplan {
    cursor: pointer;
  }

  .hideinfo {
    display: none;
  }

  .logo {
    display: flex;
    justify-content: space-between;
    background-size: 120px;
    background-repeat: no-repeat;
    background-image: url(img/azubmesse_logo_150px.png);
    background-position: right;
    width: 97%;
  }

  .search {
    position: sticky;
    top: 15px;
    width: 97%;
    margin-bottom: 1em;
  }

  .ergebnisse {
    font-family: "Segoe UI", Frutiger, "Frutiger Linotype", "Dejavu Sans",
      "Helvetica Neue", Arial, sans-serif;
    margin: 0 0.5rem 0.5rem 0.5rem;
  }

  .ergebnisse h3 {
    display: flex;
    justify-content: center;
    margin-block-start: 0.1em;
    margin-block-end: 0.3em;
    cursor: pointer;
    padding: 0.5rem;
    /* background-color: #a3ccee; */
    /* background-color: #fadcbe; */
    background-color: rgba(167, 210, 190, 0.3);
    color: #333;
    font-size: 1.2em;
    font-weight: 500;
    border-bottom: 1px solid rgba(167, 210, 190, 1);
    /* https://www.cssmatic.com/box-shadow */
    /* -webkit-box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.16);
    -moz-box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.16); */
  }

  .ergebnisse p {
    font-weight: normal;
    font-size: 1em;
    font-style: italic;
    margin: 0 0.5em 1em 0.5em;
  }

  .mini {
    font-size: 0.8em;
    width: 50%;
  }

  .firmen {
    display: flexbox;
    justify-content: space-between;
    padding-left: 2rem;
    line-height: 2em;
    cursor: pointer;
    margin-bottom: 1em;
    padding-bottom: 1em;
  }

  input[type="search"] {
    background-color: rgba(228, 234, 245, 1);
    padding: 0 1rem 0 1rem;
    -webkit-appearance: none;
    width: 100%;
    height: 3em;
    border: none;
    border-bottom: 2px solid #006699;
    font-size: 1.2em;
  }

  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: searchfield-cancel-button;
    right: 0.4em;
    position: relative;
  }

  input[type="search"]:focus {
    outline: none;
    border: none;
    border-bottom: 4px solid #ec661c;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 2em;
  }

  th,
  td {
    padding: 18px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  tr:hover {
    background-color: #f5f5f5;
  }

  .raumplanschalter {
    white-space: nowrap;
    padding: 10px 10px 10px 50px;
    border-radius: 0.5em;
    cursor: pointer;
    background-size: 20%;
    background-repeat: no-repeat;
    background-image: url(img/karte_link.svg);
    background-position: left;
  }

  .Obergeschoss {
    background-color: #ec661c;
    color: white;
  }
  .Erdgeschoss {
    background-color: #006699;
    color: white;
  }
  .Außenbereich {
    background-color: #cc3f8b;
    color: white;
  }
  .Tiefgarage {
    background-color: #74af9b;
    color: white;
  }
</style>

<header>
  <div class="logo">
    <h4>
      Ausbildungs-Suche
      <small>(BETA)</small>
    </h4>
  </div>
</header>

<search>
  <div class="search">
    <input
      type="search"
      placeholder="Suche..."
      bind:value={suchbegriff}
      on:keyup={suche} />
  </div>
</search>

<main>
  {#if anzeigeRaumplan}
    <div transition:fade class="raumplan" on:click={toggleRaumplan}>
      <Raumplan {bereich} {standnr} />
    </div>
  {:else if isLoading}
    <LoadingSpinner />
  {:else}
    <div class="ergebnisse" transition:fade>
      <!-- <button on:click={test}>ITEMTEST</button> -->
      {#each Object.keys(items) as item, i}
        <h3 on:click={() => (showinfo[i] = !showinfo[i])} transition:fade>{item}</h3>
        {#if showinfo[i]}
          <div transition:fade>
            <p>{items[item][0]['Beschreibung']}</p>
            <table>
              <tr>
                <th>Firmenname</th>
                <th>Raumplan</th>
              </tr>
              {#each items[item] as angebot}
                <tr>
                  <td>
                    <span>{angebot.Firma}</span>
                  </td>
                  <td>
                    <span
                      class="raumplanschalter {angebot.Bereich}"
                      on:click={() => toggleRaumplan(angebot.Bereich, angebot.Standnummer)}>
                      {angebot.Bereich} / Stand {angebot.Standnummer}
                    </span>
                  </td>
                </tr>
              {:else}Kein Unternehmen vorhanden.{/each}
            </table>
          </div>
        {/if}
      {:else}
        <h2>Keine Angebote gefunden.</h2>
        <p>
          Du kannst nach einer Ausbildung oder einer Firma suchen. Auch die
          Suche nach passenden Stichworten (z.B. Kfz oder Finanz) ist möglich.
        </p>
      {/each}
    </div>
  {/if}
</main>
<Footer />
